import {CCol, CContainer, CRow} from '@coreui/react-pro'
import React from 'react'
import Logo from '../../assets/brand/logo-negative.svg'
import Facebook from '../../assets/icons/facebook.svg'
import Instagram from '../../assets/icons/instagram.svg'
import Twitter from '../../assets/icons/twitter.svg'
import Youtube from '../../assets/icons/youtube.svg'
import LinkedIn from '../../assets/icons/linkedin.svg'
import {HashLink as Link} from 'react-router-hash-link'
import {BsFillArrowUpCircleFill} from 'react-icons/bs'

const Footer = () => {
  const social = [
    {icon: Facebook, path: 'https://web.facebook.com/OutsourceGblAcademy'},
    {icon: Instagram, path: 'https://www.instagram.com/academyogtl'},
    {icon: Twitter, path: 'https://twitter.com/AcademyOgtl'},
    {
      icon: Youtube,
      path: 'https://www.youtube.com/channel/UCTbT2U9hbLthG833RIHYjeQ/videos?app=desktop&view=0&sort=dd&shelf_id=0',
    },
    {
      icon: LinkedIn,
      path: 'https://www.linkedin.com/showcase/outsource-global-academy',
    },
  ]
  return (
    <div className="mt-5 footer-style  footer-font ">
      <CContainer className="py-5">
        <CRow>
          <CCol xs={{span: 12}} md={{span: 3}}>
            <img src={Logo} alt="logo" className="logo"/>
            <div className="section-spacing py-3">
              <h6>Follow Us</h6>
              {social.map(({icon, path}) => {
                return (
                  <span key={icon} className="px-1">
                    <a href={path} rel="noreferrer" target="_blank">
                      <img src={icon} alt="Icons" className="text-white"/>
                    </a>
                  </span>
                )
              })}
            </div>
            <div className="section-spacing">
              <h6>Address</h6>
              <p>
                2nd Floor, ASTA GALLERY Plot 1185, Parkway Road, Cadastral Zone, Mabushi District,
                Abuja FCT, Nigeria.
              </p>
            </div>
          </CCol>
          <CCol
            className="footer-col footer-1 "
            sm={{bg: 'white'}}
            xs={{span: 6}}
            md={{span: 3}}
          >
            <div>
              <h6>About Us</h6>
              <p><Link to="/#" className="text-decoration-none text-white">Our story</Link></p>
              <p><Link to="/#" className="text-decoration-none text-white">Contact us</Link></p>
              <p><Link to="/#" className="text-decoration-none text-white">Blog</Link></p>
            </div>
          </CCol>
          <CCol
            className="footer-col footer-2 d-flex justify-content-center"
            xs={{span: 6}}
            md={{span: 3}}
          >
            <div>
              <h6>Courses</h6>
              <p><Link to="/course/full-stack-development" className="text-decoration-none text-white">Full Stack Development</Link></p>
              <p><Link to="/course/data-science" className="text-decoration-none text-white">Data Science/Engineering</Link></p>
              <p><Link to="/#" className="text-decoration-none text-white">Software Engineering</Link></p>
              <p><Link to="/#" className="text-decoration-none text-white">Cloud Engineering</Link></p>
              <p><Link to="/#" className="text-decoration-none text-white">AI/Machine Learning</Link></p>
            </div>
          </CCol>

          <CCol
            className="footer-contact footer-col footer-3 d-flex justify-content-end"
            xs={{span: 12}}
            md={{span: 3}}
          >
            <div>
              <h6>Contact Us</h6>
              <p>
                <a className="footer-a" href="mailto:info.academy@outsourceglobal.com">
                  info.academy@outsourceglobal.com
                </a>
              </p>
              <p>
                <a className="footer-a" href="tel:+234700688768723">
                  +234 7006 8876 8723
                </a>
              </p>

              <div className="section-spacing text-center" style={{
                position: 'fixed',
                right: '10px',
                bottom: '10px',
                zIndex: '100',
                padding: '10px'
              }}>
                <Link to="/#hero">
                  <BsFillArrowUpCircleFill className="go-up"/>
                </Link>
                {/*<p className="go-up-text">Back to top</p>*/}
              </div>
            </div>
          </CCol>
        </CRow>
      </CContainer>
      <div className="d-flex justify-content-center">
        <p className="mx-3"><Link to="/#" className="text-decoration-none text-white">Terms and Conditions</Link></p>
        <p className="mx-3"><Link to="/#" className="text-decoration-none text-white">Privacy Statement</Link></p>
        <p className="mx-3"><Link to="/#" className="text-decoration-none text-white">Data Protection</Link></p>
      </div>
      <hr/>
      <p className="text-center pb-3 m-0">Copyright Outsource Global Academy. 2022</p>
    </div>
  )
}

export default Footer
